import { createFileRoute } from "@tanstack/react-router";

import { MirrorPage } from "@/components/MirrorPage";
import { content } from "@/mirror/page/privacy-candidates";
import { requireUnlockedHome } from "@/lib/gate.functions";
import { mirrorHead } from "@/mirror/pages";

export const Route = createFileRoute("/privacy/candidates")({
  loader: () => requireUnlockedHome(),
  head: () => mirrorHead("privacy-candidates"),
  component: () => <MirrorPage key="privacy-candidates" slug="privacy-candidates" content={content} />,
});
